import React, { useContext, useState } from 'react'
import { Button, Card, Col, Container, Form, InputGroup, Row, Spinner, Table } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { AuthContext, ThemeContext } from '../../../auth';
import { HeaderWeb, SidebarComponent } from '../../../components';
import { FaWindowClose } from 'react-icons/fa';
import { ModalTambahPcpSewaDetail } from '../../../components/Modal';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../../api';


function PcpSewa() {

    const { theme } = useContext(ThemeContext);
    const location = useLocation();
    const { data } = location.state || {};
    const { showSidebar, accessToken, userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [projectName, setProjectName] = useState('');
    const [wapu, setWapu] = useState(false);
    const [description, setDescription] = useState('');
    const [franco, setFranco] = useState('Jakarta');
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1)
    }

    const [pcpData, setPcpData] = useState([]);

    const [showAddPcpSewaDetail, setShowAddPcpSewaDetail] = useState(false);

    const handleShowPcpSewaDetail = () => {
        setShowAddPcpSewaDetail(true)
    };

    const [ppnPercentage, setPpnPercentage] = useState(11);

    const totalHargaJual = pcpData.reduce((total, item) => total + (item.subtotal || 0), 0);

    const ppnAmount = totalHargaJual * (ppnPercentage / 100);

    const grandTotalRaw = totalHargaJual + ppnAmount;

    // Pembulatan grandTotal
    const remainder = grandTotalRaw % 100;
    const grandTotal = remainder >= 50
        ? Math.round(grandTotalRaw + (100 - remainder))
        : Math.round(grandTotalRaw - remainder);

    const handleDeletePcpLocal = async (index) => {
        const result = await Swal.fire({
            title: 'Apakah anda yakin ingin menghapus produk ini?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, hapus produk ini!',
            cancelButtonText: 'Batalkan',
        });

        if (result.isConfirmed) {

            const updatedPcpData = pcpData.filter((_, i) => i !== index);
            setPcpData(updatedPcpData);

        } else {
            <></>
        }
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputBodyGroup: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            maxHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputQty: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }
    };

    const handleSubmitPCP = async (event) => {

        event.preventDefault();

        const result = await Swal.fire({
            title: 'Ajukan PCP?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Ajukan',
            cancelButtonText: 'Batal',
        });

        if (result.isConfirmed) {


            setIsSubmitting(true);
            setDisabled(true);

            const dataPCP = {
                username: userInfo?.username,
                projectName: projectName,
                status: 'pending',
                leadId: data?.id,
                description: description,
                isWapu: wapu,
                franco: franco,
                salesTotal: parseInt(totalHargaJual),
                ppnPercentage: parseInt(ppnPercentage),
                ppn: ppnAmount,
                grandTotal: grandTotal,
                details: pcpData
            };

            try {

                const response = await axiosAuth.post(`/api/pcp/sewa`, dataPCP, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        withCredentials: true,
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                handleBack();

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil mengajukan PCP',
                    showConfirmButton: true,
                });

                setIsSubmitting(false);
                setDisabled(false);

            } catch (err) {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan saat pengajuan PCP',
                });

                setIsSubmitting(false);
                setDisabled(false);

            } finally {

                setIsSubmitting(false);
                setDisabled(false);

            }

        } else {
            <></>
        }
    };

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }} >
            <SidebarComponent />
            <div
                id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'ms-2' : 'ms-3'}>
                    <Row>
                        <Col xs={6} lg={6} className='text-start'>
                            <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                PCP Sewa
                            </h3>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderWeb />
                        </Col>
                    </Row>
                </div>
                <Form >
                    <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4'}>
                        <Row>
                            <Col xs={12} lg={4} className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='customer'>Customer</Form.Label>
                                <Form.Control
                                    id='customer'
                                    type="text"
                                    defaultValue={
                                        data?.customer?.title?.titleName === "Others"
                                            ? data?.customer?.name
                                            : `${data?.customer?.title?.titleName}. ${data?.customer?.name}`
                                    }
                                    readOnly
                                    style={formStyles.input}
                                />
                            </Col>
                            <Col xs={12} lg={4} className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='project'>Nama Projek*</Form.Label>
                                <Form.Control
                                    id='project'
                                    type="text"
                                    onChange={(e) => setProjectName(e.target.value)}
                                    value={projectName}
                                    required
                                    style={formStyles.input}
                                />
                            </Col>
                            <Col xs={12} lg={3} className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='top'>Term of Payment*</Form.Label>
                                <InputGroup >
                                    <Form.Control
                                        id="top"
                                        type="text"
                                        defaultValue={data?.customer?.top || ''}
                                        readOnly
                                        placeholder="Term of Payment"
                                        style={formStyles.input}
                                    />
                                    <InputGroup.Text
                                        style={formStyles.input}
                                        id="basic-addon1"
                                    >
                                        Hari
                                    </InputGroup.Text>
                                </InputGroup>
                            </Col>
                            <Col xs={12} lg={1} className="mb-3">
                                <Form.Label style={formStyles.label}>Wapu</Form.Label>
                                <Form.Check
                                    type='checkbox'
                                    id='default-checkbox'
                                    onChange={(e) => setWapu(e.target.checked)}
                                    value={wapu}
                                    style={formStyles.label}
                                    disabled={pcpData.length !== 0}
                                />
                            </Col>
                            <Col xs={12} lg={4} className="mb-3">
                                <Form.Label style={formStyles.label}>Franco*</Form.Label>
                                <Form.Control
                                    id='franco'
                                    type="text"
                                    onChange={(e) => setFranco(e.target.value)}
                                    value={franco}
                                    required
                                    style={formStyles.input}
                                />
                            </Col>
                            <Col xs={12} lg={4} className="mb-3">
                                <Form.Group >
                                    <Form.Label style={formStyles.label} htmlFor='description'>Syarat dan ketentuan tambahan</Form.Label>
                                    <Form.Control
                                        id="description"
                                        as="textarea"
                                        rows={3}
                                        onChange={(e) => setDescription(e.target.value)}
                                        value={description}
                                        placeholder="Syarat dan ketentuan tambahan"
                                        style={formStyles.input}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>

                    <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4 me-3'}>
                        <h3 className='text-center' style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222', fontSize: isMobile ? '25px' : '38px' }}>
                            PCP Detail
                        </h3>
                        <div>
                            <Row>
                                <Col xs={12} lg={6} className='text-start'>
                                    <Button
                                        variant='btn'
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        disabled={
                                            !data ||
                                            !projectName ||
                                            !franco
                                        }
                                        onClick={handleShowPcpSewaDetail}
                                    >
                                        Tambah
                                    </Button>
                                </Col>
                            </Row>
                        </div>

                        <Table className='mt-4' bordered responsive data-bs-theme={theme === "light" ? "dark" : "light"}>
                            <thead>
                                <tr style={{ fontFamily: 'Poppins-Regular', textAlign: 'center' }}>
                                    <th
                                        style={{
                                            textAlign: 'left'
                                        }}
                                    >
                                        Nama Produk
                                    </th>
                                    <th>Jenis Produk</th>
                                    <th
                                        style={{
                                            textAlign: 'center'
                                        }}
                                    >
                                        Durasi (Bulan)
                                    </th>
                                    <th
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    >
                                        Harga Beli
                                    </th>
                                    <th
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    >
                                        Harga Sewa Perbulan
                                    </th>
                                    <th>Qty</th>
                                    <th
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    >
                                        Sub Total
                                    </th>
                                    <th
                                        style={{
                                            textAlign: 'center'
                                        }}
                                    >
                                        %
                                    </th>
                                    <th>Hapus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pcpData.map((item, index) => (
                                    <tr key={index} style={{ fontFamily: 'Poppins-Light', textAlign: 'center' }}>
                                        <td style={{
                                            textAlign: 'left',
                                            width: '350px'
                                        }}>
                                            {item.productName}
                                        </td>
                                        <td>
                                            {item.categoryName}
                                        </td>
                                        <td style={{
                                            textAlign: 'center'
                                        }}>
                                            {(item.duration / 30)}
                                        </td>
                                        <td style={{
                                            textAlign: 'right'
                                        }}>
                                            {numberFormat(item.buyingPrice)}
                                        </td>
                                        <td
                                            style={{
                                                textAlign: 'right'
                                            }}
                                        >
                                            {numberFormat(item.sellingPrice)}
                                        </td>
                                        <td >
                                            {item?.quantity}
                                        </td>
                                        <td
                                            style={{
                                                textAlign: 'right'
                                            }}
                                        >
                                            {numberFormat(item.subtotal)}
                                        </td>
                                        <td
                                            style={{
                                                textAlign: 'center'
                                            }}
                                        >
                                            <span style={{
                                                color: item.validateMargin == true ? '#16C47F' : '#FF0060'
                                            }}>
                                                {item.margin ? `${item.margin}%` : '0%'}
                                            </span>
                                        </td>
                                        <td>
                                            <div>
                                                <Button
                                                    variant='btn'
                                                    onClick={() => handleDeletePcpLocal(index)}
                                                    style={{
                                                        border: 'none',
                                                        backgroundColor: 'transparent',
                                                    }}
                                                >
                                                    &nbsp;<FaWindowClose size={20} color='#FF0060' />&nbsp;
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <div className='mt-5'>
                            <Row>
                                <Col xs={12} lg={6} ></Col>
                                <Col xs={12} lg={2} ></Col>
                                <Col xs={12} lg={4} >
                                    <Card
                                        data-bs-theme={theme === 'light' ? 'dark' : ''}>
                                        <Card.Body>
                                            <div>
                                                <Form.Label style={formStyles.label} htmlFor='totalSelling'>Total Harga Jual</Form.Label>
                                                <Form.Control
                                                    id='totalSelling'
                                                    type='text'
                                                    className='mb-3'
                                                    value={numberFormat(totalHargaJual) || ''}
                                                    readOnly
                                                    style={formStyles.input}
                                                />
                                                <Form.Label style={formStyles.label} htmlFor='ppn'>PPN%</Form.Label>
                                                <Form.Control
                                                    id='ppn'
                                                    type='text'
                                                    className='mb-3'
                                                    value={ppnPercentage}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            setPpnPercentage(value);
                                                        }
                                                    }}
                                                    required
                                                    style={formStyles.input}
                                                />
                                                <Form.Label style={formStyles.label} htmlFor='ppnValue'>PPN Amount</Form.Label>
                                                <Form.Control
                                                    id='ppnValue'
                                                    type='text'
                                                    className='mb-3'
                                                    value={numberFormat(ppnAmount) || ''}
                                                    readOnly
                                                    style={formStyles.input}
                                                />
                                                <Form.Label style={formStyles.label} htmlFor='grandTotal'>Grand Total</Form.Label>
                                                <Form.Control
                                                    id='grandTotal'
                                                    type='text'
                                                    className='mb-3'
                                                    value={numberFormat(grandTotal) || ''}
                                                    readOnly
                                                    style={formStyles.input}
                                                />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                    <div className='text-end mt-4 mb-3'>
                                        {isSubmitting ? (
                                            <Button
                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                variant='btn'
                                                disabled
                                                style={{ minWidth: '90px' }}
                                            >
                                                <Spinner
                                                    animation="border"
                                                    size='sm'
                                                />
                                            </Button>
                                        ) : (
                                            <Button
                                                variant='btn'
                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                onClick={handleSubmitPCP}
                                                disabled={disabled ||
                                                    pcpData == 0
                                                }
                                            >
                                                Simpan
                                            </Button>
                                        )}
                                        <Button
                                            variant='secondary'
                                            className='ms-3'
                                            onClick={handleBack}
                                            style={{ fontFamily: 'Poppins-Regular', minHeight: '45px' }}
                                        >
                                            Kembali
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Form>
            </div>
            <ModalTambahPcpSewaDetail
                showAddPcpSewaDetail={showAddPcpSewaDetail}
                setShowAddPcpSewaDetail={setShowAddPcpSewaDetail}
                formStyles={formStyles}
                wapu={wapu}
                onSave={(newData) => setPcpData((prev) => [...prev, newData])}
            />
        </div>
    )
}

export default PcpSewa
